import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["className", "color", "size", "tint"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Box from '../box';
import cx from 'classnames';
import theme from './theme.css';
/** @type {React.ComponentType<any>} */

var LoadingSpinner = /*#__PURE__*/function (_PureComponent) {
  _inherits(LoadingSpinner, _PureComponent);

  var _super = _createSuper(LoadingSpinner);

  function LoadingSpinner() {
    _classCallCheck(this, LoadingSpinner);

    return _super.apply(this, arguments);
  }

  _createClass(LoadingSpinner, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          color = _this$props.color,
          size = _this$props.size,
          tint = _this$props.tint,
          others = _objectWithoutProperties(_this$props, _excluded);

      var classNames = cx(theme['loading-spinner'], theme["is-".concat(color)], theme["is-".concat(size)], theme["is-".concat(tint)], className);
      return /*#__PURE__*/React.createElement(Box, _extends({
        "data-teamleader-ui": "loading-spinner",
        className: classNames
      }, others));
    }
  }]);

  return LoadingSpinner;
}(PureComponent);

LoadingSpinner.defaultProps = {
  color: 'teal',
  size: 'medium',
  tint: 'darkest'
};
export default LoadingSpinner;